// extracted by mini-css-extract-plugin
export default {"open-sans":"\"Open Sans\",sans-serif","poppins":"\"Poppins\",sans-serif"};